import monthlyBasicPlanPNG from '../assets/images/subscripiton-checkout-icons/monthly-basic-plan-banner.png';
import semesterBasicPlanPNG from '../assets/images/subscripiton-checkout-icons/semester-basic-plan-banner.png';
import anualBasicPlanPNG from '../assets/images/subscripiton-checkout-icons/anual-basic-plan-banner.png';
import monthlyPremiumPlanPNG from '../assets/images/subscripiton-checkout-icons/monthly-premium-plan-banner.png';
import semesterPremiumPlanPNG from '../assets/images/subscripiton-checkout-icons/semester-premium-plan-banner.png';
import anualPremiumPlanPNG from '../assets/images/subscripiton-checkout-icons/anual-premium-plan-banner.png';
import basicPlan590 from '../assets/images/subscripiton-checkout-icons/basic-plan-590.png';
import anualBasicPlanDiscountPNG from '../assets/images/subscripiton-checkout-icons/anual-basic-plan-discount-banner.png';

// --------- PLANOS PARA TESTE --------- //
// Plano TESTE Básico = 'plan_EkBJB2C6mflAJqwe'
// Plano TESTE Pro 5 looks = 'plan_5Bkg2raH1I8LgRW0'
// Plano TESTE Pro 10 looks = 'plan_0rNDqPxcWfp7LoK4'

// --------- PLANOS LIVE --------- //
// Plano LIVE Básico = 'plan_3zqL3mSwOIv09eJ5'
// Plano LIVE Pro 5 looks = 'plan_QrZAaGviGTPPBzRW'
// Plano LIVE Pro 10 looks = 'plan_8B6XMOdI7gcGVgdK'
// Plano LIVE para TESTAR! = plan_Bxk9xeDsr1u4bAOv

export const subscriptionPlans = [
  {
    id: 0,
    planId: 'plan_3zqL3mSwOIv09eJ5',
    planImage: monthlyBasicPlanPNG,
    planImageDiscount: null,
    planName: 'Plano Básico Completo',
    originalPrice: 2990,
    price: 1990,
    discountPrice: null,
  },
  {
    id: 1,
    planId: 'plan_059NGAQCOCnGgAOk',
    planImage: basicPlan590,
    planImageDiscount: null,
    planName: 'Plano Básico Completo',
    originalPrice: 3990,
    price: 590,
    discountPrice: null,
  },
  {
    id: 2,
    planId: 'plan_mL3WqlLHoHnqxowP',
    planImage: semesterBasicPlanPNG,
    planImageDiscount: null,
    planName: 'Plano Básico Completo Semestral',
    originalPrice: 17940,
    price: 9990,
    discountPrice: null,
  },
  {
    id: 3,
    planId: 'plan_vxgWB0lcQMCrDQNX',
    planImage: anualBasicPlanPNG,
    planImageDiscount: anualBasicPlanDiscountPNG,
    planName: 'Plano Básico Completo Anual',
    originalPrice: 35880,
    price: 19990,
    discountPrice: 13790,
  },
  {
    id: 4,
    planId: 'plan_2ZPqX7dUowf84LBO',
    planImage: monthlyPremiumPlanPNG,
    planImageDiscount: null,
    planName: 'Plano Premium Mensal',
    originalPrice: 4990,
    price: 3990,
    discountPrice: null,
  },
  {
    id: 5,
    planId: 'plan_72XLnP3TatDQZQA0',
    planImage: semesterPremiumPlanPNG,
    planImageDiscount: null,
    planName: 'Plano Premium Semestral',
    originalPrice: 29940,
    price: 20990,
    discountPrice: null,
  },
  {
    id: 6,
    planId: 'plan_ejE3L1yiYuBn2Nz7',
    planImage: anualPremiumPlanPNG,
    planImageDiscount: null,
    planName: 'Plano Premium Anual',
    originalPrice: 59880,
    price: 35990,
    discountPrice: null,
  },
];
